(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('PrestacaoServicos', PrestacaoServicos);

  PrestacaoServicos.$inject = [
    '$http'
  ];

  // eslint-disable-next-line max-lines-per-function
  function PrestacaoServicos($http) {
    const params = {
      cd_combustivel: 1,
      cd_tipo: 3,
      quantidade: 10,
      hora_inicial_mec: '9957',
      hora_final_mec: '9957',
      nr_horimetro: 1,
      qt_horas: 0,
      cd_produtor: 1660,
      cd_propriedade: 14,
      cd_safra: 17,
      cd_maquina: 11,
      dt_inicial_ps: '2018-06-04',
      hora_inicial_tempo: '00:00',
      dt_final_ps: '2018-06-04',
      hora_final_tempo: '00:00',
      qt_horas_tempo: '00:00',
      cd_operador: 804,
      cd_operacao: 31,
      hash_objeto: '837a17e1a550fcbe6d70fed0666b7956c4f492eb',
      st_tipo_lanc_operacao: 'O',
      st_tipo_lancamento: 'M',
      st_tipo_uso_maquina: 'M',
      st_modalidade: 'P',
      st_cobrar_combustivel: 'N',
      cd_empresa: 5,
      hora_inicial_ps: '2018-06-04 00:00:00 -0300',
      hora_final_ps: '2018-06-04 00:00:00 -0300'
    };
    return {
      testFormula,
      params,
      list
    };

    // eslint-disable-next-line no-shadow
    function list(params) {
      return $http.get(`${SERVER}/v1/prestacao_servicos`, {
        params
      });
    }

    function testFormula(formula) {
      return $http.post(`${SERVER}/v1/formulas/test`, {
        params,
        formula
      });
    }
  }
}());
